module.exports = __webpack_public_path__ + "static/media/knitty-gritty.0fea845a.png";